import { UniversalCard } from '@components/core-ui/UniversalCard';
import { routes } from '@routes';
import { OrganizationTeamWithMembersResponseDto } from 'app/API';
import { Link } from 'react-router-dom';

type TProps = {
  team: OrganizationTeamWithMembersResponseDto;
};

export const TeamCard = ({ team }: TProps) => {
  const content = (
    <>
      <Link
        to={routes.adminTeamDetails.make(team.id)}
        className="font-medium text-[var(--color-title)] hover:text-foreground-muted"
      >
        {team.name || team.slug}
      </Link>
      <p>&nbsp;</p>
      {team.members !== undefined ? (
        <p className="text-foreground-muted text-xs">
          {team.members} {team.members === 1 ? 'member' : 'members'}
        </p>
      ) : null}
    </>
  );

  return <UniversalCard backgroundColor={team.colour} content={content} name={team.name || team.slug} />;
};
